angular
  .module('ATMGurus')
  .component('atmgHead', {
    bindings: {
      
    },
    template: require('Templates/main/head.html'),
    bindToController: {
    },
    scope: true,
    controllerAs: 'MainCtrl',
    controller: makeControllerFn()
  })

  function makeControllerFn() {
    return class AtmgHead {

      constructor($scope, Navigation, FilterService) {
        this.Navigation = Navigation
        this.FilterService = FilterService
      }
    }
  }


// WEBPACK FOOTER //
// ./src/app/components/atmgHead.js